import { LANGS, type Lang } from "../src/languages";
import { h } from "./dom";
import { LANG, switchLang } from "./i18n";
import { LANGUAGE_NAMES, STRINGS } from "./strings";

/**
 * UI language switcher. `compact` shows "EN"/"ES" (tight headers); otherwise each language
 * is written in itself ("English", "Español") so anyone can find their own.
 */
export function uiLangSelect(compact = false): HTMLSelectElement {
  const select = h(
    "select",
    { class: "select select-lang", "aria-label": STRINGS.uiLanguageLabel, title: STRINGS.uiLanguageLabel },
    ...LANGS.map((lang) => h("option", { value: lang }, compact ? lang.toUpperCase() : LANGUAGE_NAMES[lang])),
  );
  select.value = LANG;
  select.addEventListener("change", () => switchLang(select.value as Lang));
  return select;
}
